function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.588 9.822a5.237 5.237 0 111.58 1.591l-1.496.25a.292.292 0 01-.336-.336l.252-1.505z",
  stroke: "#008AF5",
  strokeWidth: ".938",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.583 4.667l-1.75 1.75 2.334 1.166-1.75 1.75",
  stroke: "#008AF5",
  strokeWidth: ".938",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));